import { List } from '@material-ui/core'
import React from 'react'
import { AnnouncementItemType, SubjectAnnouncementModel } from '../clients.model'
import AnnouncementListItem from './AnnouncementListItem'

export interface AnnouncementListProps {
  announcementItems: SubjectAnnouncementModel
  subjectType: number
}

const AnnouncementList: React.FC<AnnouncementListProps> = ({ announcementItems, subjectType }) => {
  return (
    <List dense={true}>
      { announcementItems.contractsSubjectNextExpiration.length > 0 ? <AnnouncementListItem
        key={`${announcementItems.contractsSubjectNextExpiration}-${AnnouncementItemType.CONTRACTS_NEXT_EXPIRATION}`}
        announcements={announcementItems}
        itemType={AnnouncementItemType.CONTRACTS_NEXT_EXPIRATION}
        subjectType={subjectType}
      /> : null }
      
      { announcementItems.activeSubjectWithoutContracts.length > 0 ? <AnnouncementListItem
        key={`${announcementItems.activeSubjectWithoutContracts}-${AnnouncementItemType.SUBJECT_WITHOUT_CONTRACTS}`}
        announcements={announcementItems}
        itemType={AnnouncementItemType.SUBJECT_WITHOUT_CONTRACTS}
        subjectType={subjectType}
      /> : null }

      { announcementItems.proceduresInProgress.length > 0 ? <AnnouncementListItem
        key={`${announcementItems.proceduresInProgress}-${AnnouncementItemType.PROCEDURES_IN_PROGRESS}`}
        announcements={announcementItems}
        itemType={AnnouncementItemType.PROCEDURES_IN_PROGRESS}
        subjectType={subjectType}
      /> : null }
      { announcementItems.incidentProcedures.length > 0 ? <AnnouncementListItem
        key={`${announcementItems.incidentProcedures}-${AnnouncementItemType.INCIDENT_PROCEDURES}`}
        announcements={announcementItems}
        itemType={AnnouncementItemType.INCIDENT_PROCEDURES}
        subjectType={subjectType}
      /> : null }
      { announcementItems.incidentProcedures.length == 0 && announcementItems.proceduresInProgress.length == 0 &&
      announcementItems.activeSubjectWithoutContracts.length == 0 && announcementItems.contractsSubjectNextExpiration.length == 0 ? <AnnouncementListItem
        key={`WithoutAnnouncement-${AnnouncementItemType.WITHOUT_ANNOUNCEMENT}`}
        announcements={announcementItems}
        itemType={AnnouncementItemType.WITHOUT_ANNOUNCEMENT}
        subjectType={subjectType}
      /> : null }
    </List>
  )
}

export default AnnouncementList
